module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_indigo.6ddd89b4.svg";